<template>
  <div class="row mt-2">
    <div class="col">
      <div v-if="data">
        <job-info
          :data="data"
          :userActions="userActions"
          v-if="view == 'detail'"
          @decline="view = 'decline'"
          @sign="view = 'sign'"
        ></job-info>
        <job-decline
          :data="data"
          v-if="view == 'decline'"
          @cancel="view = 'detail'"
          @decline="decline"
        ></job-decline>
        <job-mobile-sign
          :data="data"
          v-if="view == 'sign'"
          @cancel="view = 'detail'"
        ></job-mobile-sign>
      </div>
      <div v-else>
        <h3 class="text-center text-muted mt-5">Yükleniyor...</h3>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import JobInfo from "../components/JobInfo.vue";
import JobDecline from "../components/JobDecline.vue";
import JobMobileSign from "../components/JobMobileSign.vue";

export default {
  components: {
    JobInfo,
    JobDecline,
    JobMobileSign
  },
  data() {
    return {
      data: null,
      userActions: null,
      view: "detail"
    };
  },
  methods: {
    getData() {
      axios.get("/job/getwithactions/" + this.$route.params.id).then(x => {
        if (x.data.Success) {
          console.log("Gelen veri: ", x);
          this.data = x.data.Data.Job;
          this.userActions = x.data.Data.UserActions;
        }
      });
    },
    decline(description) {
      return axios
        .post("/job/decline", { JobId: this.data.Id, description: description })
        .then(x => {
          console.log("POST Result:", x.data);

          if (x.data.Success) {
            this.data = x.data.Data.Job;
            this.userActions = x.data.Data.UserActions;
            this.view = "detail";
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
          }
        })
        .catch(x => window.processErrorResponse(x, this));
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
.table.ozet > tbody > tr > td {
  padding: 1px 3px;
}

.table.ozet > tbody > tr > td:first-child {
  color: #666;
  padding-left: 0;
  white-space: nowrap;
}

.table.ozet > tbody > tr > td:nth-child(2) {
  font-weight: bold;
  width: 1px;
}

.commands {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.commands .btn {
  border-radius: 0;
}
</style>
